import {
  GET_DROPBOX_TOKEN_SUCCESS,
  GET_DROPBOX_TOKEN_FAILURE,
  GET_GOOGLE_DRIVE_TOKEN_SUCCESS,
  GET_GOOGLE_DRIVE_TOKEN_FAILURE,
  DELETE_GOOGLE_DRIVE_CREDENTIAL_SUCCESS,
  ADD_DROPBOX_CREDENTIAL_SUCCESS,
  ADD_GOOGLE_DRIVE_CREDENTIAL_SUCCESS
} from '../constants/actionTypes';

const INITIAL_STATE = { googleDrive: {}, dropbox: {} };

export default function cloudStorage(state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_GOOGLE_DRIVE_TOKEN_SUCCESS:
      return {
        ...state,
          access_token: action.payload.data.attributes.auth_keys.access_token,
          gdriveClientId: action.payload.data.attributes.gdrive_client_id,
          gdriveApiKey: action.payload.data.attributes.gdrive_api_key

      };
    case GET_GOOGLE_DRIVE_TOKEN_FAILURE:
    case GET_DROPBOX_TOKEN_FAILURE:
      return { ...state, googleDrive: {}, dropbox: {} };
    case GET_DROPBOX_TOKEN_SUCCESS:
      return { ...state, dropboxCredId: action.payload.data.id };
    case ADD_DROPBOX_CREDENTIAL_SUCCESS:
      return { ...state, dropboxCredId: action.payload.data.id }
    case ADD_GOOGLE_DRIVE_CREDENTIAL_SUCCESS:
      return { ...state,
          access_token: action.payload.data.attributes.auth_keys.access_token,
          gdriveClientId: action.payload.data.attributes.gdrive_client_id,
          gdriveApiKey: action.payload.data.attributes.gdrive_api_key

      };
    case DELETE_GOOGLE_DRIVE_CREDENTIAL_SUCCESS:
      return { ...state, googleDriveCred: {}}
    default:
      return state;
  }
}
